import { FC } from 'react';
import { useRouteError } from 'react-router-dom';

import { ContentBox, ErrorMessage } from '@components/base';

export const ErrorBoundary: FC = () => {
  const error = useRouteError() as Error;
  console.error(error);

  return (
    <ContentBox>
      <ErrorMessage error={error} />
    </ContentBox>
  );
};
